import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import ApiVersion from '../api-versions';
import { DataHttpCommonService } from '../data-http-common.service';
import {
	EpDataHttpService,
	IGetEpLookupValuesParams,
	IGetEpLookupValuesResult,
	IGetEpSelectValuesParams,
	IGetEpSelectValuesResult,
} from './abstract';
import { IEpTableDataDto, IEpTableSettingsDto, IGetTableDataCriteria, IGetTableSettingsCriteria } from './table';

@Injectable()
export class EpDataHttpServiceImpl implements EpDataHttpService {
	constructor(public readonly http: HttpClient, public readonly common: DataHttpCommonService) {}

	getTableSettings({ epId, subcatId, taskId }: IGetTableSettingsCriteria): Observable<IEpTableSettingsDto> {
		const url = this.common.getApiUrl(
			`ep/tableSettings/${epId}/subcat/${subcatId}${taskId ? '/' + taskId : ''}`,
			ApiVersion.v12
		);
		return this.http.get<IEpTableSettingsDto>(url);
	}

	getTableData<T = any>({ epId, taskId, meta }: IGetTableDataCriteria): Observable<IEpTableDataDto<T>> {
		const url = this.common.getApiUrl(`task/${taskId}/ep/table/${epId}`, ApiVersion.v12);
		return this.http.post<IEpTableDataDto<T>>(url, meta);
	}

	getEpSelectValues(params: IGetEpSelectValuesParams): Observable<IGetEpSelectValuesResult> {
		const url = this.common.getApiUrl(`ep/select`, ApiVersion.v12);
		return this.http.post<IGetEpSelectValuesResult>(url, params);
	}

	getEpLookupValues(params: IGetEpLookupValuesParams): Observable<IGetEpLookupValuesResult> {
		const url = this.common.getApiUrl(`ep/lookup`, ApiVersion.v12);
		return this.http.post<IGetEpLookupValuesResult>(url, params);
	}
}
